// Et bevis kan hoejst baere 54 lektioner, svarende til kravet for en hel periode.
// Kategoriloftene (undervisning 27, forfatterskab 18, ...) haandteres ved
// indberetning, ikke her — se calculateReportCategorySummaries.
export const MAX_LESSONS_PER_EVIDENCE = 54;

// Lektionstal foelger dokumentationen, de kommer fra, og den lyder ikke altid paa et
// helt eller halvt tal — et kursusbevis kan sige 12,34. Serveren afrunder til to
// decimaler (cle-compliance-api round_lessons), og felterne bruger step="any", saa
// browseren ikke afviser tallet foerst.
export const LESSON_DECIMALS = 2;

/** Afrunder som serveren, saa visningen matcher det, der bliver gemt. */
export const roundLessons = (value: number): number =>
  Number(value.toFixed(LESSON_DECIMALS));

/**
 * Er tallet et brugbart lektionstal? Der er bevidst ingen decimalgraense: finere
 * praecision afrundes af serveren i stedet for at blive afvist. Vi spaerrer kun for
 * det, serveren ogsaa spaerrer for — nul, negative tal og tal over loftet — og for en
 * vaerdi saa lille, at den ville afrunde til nul.
 */
export const isValidLessonCount = (value: number): boolean =>
  Number.isFinite(value) &&
  roundLessons(value) > 0 &&
  value <= MAX_LESSONS_PER_EVIDENCE;

/**
 * Viser et lektionstal med dansk komma og uden efterfoelgende nuller. Uden en vaerdi
 * returneres `fallback`, som er tom streng — det er, hvad tabelcellerne viste i forvejen.
 */
export const formatLessons = (
  value: number | null | undefined,
  fallback = "",
): string =>
  value == null
    ? fallback
    : roundLessons(value).toLocaleString("da-DK", {
        maximumFractionDigits: LESSON_DECIMALS,
      });
